export enum ETipoUsuario {
  ADMINISTRADOR_SISTEMA = 1,
  ADMINISTRADOR_EMPRESA = 2,
  INSPECTOR = 3,
  ADMINISTRADOR_INSPECTOR = 4,
}
